import http from "@/axios/http-common";
import { Skrining } from "@/types/skrining";

async function createSkriningBatuk(params: any): Promise<any> {
  const { data } = await http.postData(`/skrining/batuk`, params).catch(err => {
    return Promise.reject(err);
  });

  return data;
}

async function updateSkriningBatuk(id: number, params: any): Promise<any> {
  const { data } = await http
    .putData(`/skrining/batuk/${id}`, params)
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function deleteSkriningBatuk(id: number): Promise<any> {
  const { data } = await http.deleteData(`/skrining/batuk/${id}`).catch(err => {
    return Promise.reject(err);
  });

  return data;
}

async function getSkriningByUnitAndDate(
  unitId: string,
  date: string
): Promise<any> {
  const { data } = await http
    .getDataParam(`/skrining`, {
      params: {
        unit_id: unitId,
        date: date
      }
    })
    .catch(err => {
      return Promise.reject(err);
    });

  return data;
}

async function getSkriningByReg(noReg: number): Promise<Skrining[]> {
  const { data } = await http
    .getData(`/register/${noReg}/skrining`)
    .catch(err => {
      return Promise.reject(err);
    });

  return data.data;
}

export default {
  createSkriningBatuk,
  updateSkriningBatuk,
  deleteSkriningBatuk,
  getSkriningByUnitAndDate,
  getSkriningByReg
};
